import React from 'react'
import { Outlet } from 'react-router-dom'

function PodianSupport() {
  return (
    <Outlet/>
  )
}

export default PodianSupport